import axios from 'axios';
// import { TEST_TOCKE } from './message';
// import { isLoadingBar } from './util';

// API 주소 — 기본은 같은 도메인(quinors.com → Caddy가 /v1/* 을 퀴노스 서버 1359로 넘긴다).
// 로컬 개발처럼 다른 주소를 쓰려면 빌드 환경변수 REACT_APP_API_BASE 로 바꾼다.
const BASE_URL = process.env.REACT_APP_API_BASE || '';
const httpAxios = axios.create({
  baseURL: BASE_URL
});

/**
 * 공통 api 통신 모듈
 * @param {String} url : api url
 * @param {String} method: get, post, delete, put
 * @param {Object} params: api url요청과 함께 전송 될 URL 매개 변수입니다
 * @param {Object} data: api url요청에 body로 전송할 데이터입니다.
 * @param {boolean} loading: 로딩바 생성 유무
 * @param {Object} cancelToken: axios CancelToken — 취소되면 응답 대신 undefined 가 돌아온다
 * @param {Object} headers: 추가 요청 헤더
 */

export const client = async ({
  url, data, params,
  loading = true, method = 'get', file = false, cancelToken, headers: extraHeaders
}, isAuth) => {

  // if (loading) isLoadingBar(true);

  let headers = { ...(extraHeaders || {}) };   // 호출 쪽 추가 헤더 (실시간문의 방문객 키 등)
  if (isAuth) {
    const token = localStorage.getItem('qwdmtk');

    if (token) headers["Authorization"] = `Bearer ${token}`;
  }


  if (file) {
    headers["Content-type"] = "multipart/form-data";
  }

  return httpAxios({
    url: `${url}`,
    method,
    data,
    params,
    headers,
    cancelToken
  })
    .then((response) => {
      // isLoadingBar(false);
      return response;
    })
    .catch((error) => {
      // isLoadingBar(false);
      if (axios.isCancel(error)) return undefined;
      return error.response;
    })
};

export const isCancelled = (resp) => resp === undefined;
